module.exports = __webpack_public_path__ + "img/flagFilled.4174663f.svg";